import _ from 'underscore';
import React from 'react';
import { withLock, keyVault } from '@bingads-webui-react/popup-manager';
import { TargetComponent, INotification } from '../types';
import { MiniCallout } from '../utils/mini-callout';

interface IFloatingBannerWrapperProps {
  notification: INotification,
  messageClassName: string,
  i18n: any,
}

class MiniCalloutWrapperInner extends React.PureComponent<IFloatingBannerWrapperProps> {
  render() {
    const { messageClassName, notification, i18n } = this.props;
    if (React.isValidElement(notification.message)) {
      return (
        <span
          className={messageClassName}
          role="alert"
        >
          { notification.message }
        </span>
      );
    }

    let wrappedMsg = (<span
      className={messageClassName}
      dangerouslySetInnerHTML={{ __html: notification.message }}
      role="alert"
    />);

    if (notification.extraOptions?.showActionFallbackCallout) {
      const doc = (new DOMParser()).parseFromString(notification.message, 'text/html');
      wrappedMsg = (
        <span className={messageClassName}>
          {_.map(doc.body.childNodes, (node, index) => {
            if (node.nodeName.toLowerCase() === 'a' && node.childNodes[0] && node.childNodes[0].parentElement) {
              const aTag = node.childNodes[0].parentElement;
              return (
                <MiniCallout
                  innerText={aTag.innerText}
                  href={aTag.getAttribute('href')}
                  i18n={i18n}
                  bannerType={TargetComponent.FloatingBanner}
                  key={index}
                />
              );
            }
            return node.textContent;
          })}
        </span>
      );
    }

    return wrappedMsg;
  }
}

export const MiniCalloutWrapper = withLock(MiniCalloutWrapperInner, {
  lockKey: keyVault.floatingBanner,
  force: true,
});
